import { IMAGE_SIZES } from '../constants/IMAGE_SIZES';
import { getLazyLinkToImage } from '../js/helpers/getLazyLinkToImage';
export const getSrcSetForLazy = (src, maxSize = IMAGE_SIZES[IMAGE_SIZES.length - 1]) => {
    const lazySrc = getLazyLinkToImage(src);
    let srcSet = '';
    for (let i = 0; IMAGE_SIZES[i] < maxSize; i++) {
        srcSet += `${lazySrc.replace('{width}', String(IMAGE_SIZES[i]))} ${IMAGE_SIZES[i]}w,`;
    }
    srcSet += `${lazySrc.replace('{width}', String(maxSize))} ${maxSize}w`;
    return srcSet;
};
